import React from 'react';
import { useDispatch } from 'react-redux';
import Backdrop from '@mui/material/Backdrop';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

import { ModalProps, DealType } from '../../store/types/types';
import { rejectRequestStart } from '../../store/reject-request/reject-request.actions';
import { StyledBox } from './reject-modal.styles';

const RejectConfirmModal = ({ isOpen, handleClose, messageId, programmatic }: ModalProps & DealType) => {
    const dispatch = useDispatch();

    const handleReject = () => {
        handleClose();
        dispatch(rejectRequestStart({ messageId, programmatic }))
    }

    return (
        <React.Fragment>
            <Modal
                aria-labelledby="rejection-modal-title"
                aria-describedby="rejection-modal-description"
                open={isOpen}
                onClose={handleClose}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500,
                }}>
                <Fade in={isOpen}>
                    <StyledBox>
                        <Typography
                        id="rejection-modal-title"
                        sx={{ fontSize: 24, fontWeight: "bold" }}
                        >
                            CONFIRM CANCELLATION
                        </Typography>
                        <Typography
                        id="rejection-modal-description"
                        >
                            Cancelling this request will delete the message from the deactivation queue.
                        </Typography>
                        <Button
                            onClick={handleReject}
                            variant="contained"
                            size="medium"
                            color="error"
                            sx={{ mt: 3 }}
                        >
                            CANCEL
                        </Button>
                    </StyledBox>
                </Fade>
            </Modal>
        </React.Fragment>
    );
}

export default RejectConfirmModal;